import React from "react";
import {Check} from "@sparkware/app-utils";
import {LiveStreamingListTitleBox} from "../../../../../components/live-streaming-tile/live-streaming-specific-components/live-streaming-list-title/live-streaming-list-title.box";
import {LiveStreamingTitleIconBox} from "../../../../../components/live-streaming-tile/live-streaming-specific-components/live-streaming-title-icon/live-streaming-title-icon.box";
import {DefaultVideoListModel} from "./default-video-list.model";
import {LIVE_STREAMING_ITEM} from "../../../../../themes/css-global-classes";

export class LiveStreamingVideoListModel extends DefaultVideoListModel {

    get templateType(): string {
        return LIVE_STREAMING_ITEM;
    }

    private _isLiveStreamDisabled = () => {
        // live stream should be rendered on mobile only, excepting CIP8, if is enable from AB and
        // if user is authorized or if is not authorized only if is not disabled prelogin
        return this.services.miniOrbit.isEnabled ||
            !this.services.abTestingFeatureDataProvider.videoLiveStream.isEnabled ||
            this.services.liveStreamPlaying.isDisabledPrelogin
    };

    protected _shouldBeDisplayed(): boolean {
        if(this._isLiveStreamDisabled()) {
            return false;
        }

        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    get maxGamesToShowInList(): number {
        return 20;
    }

    protected _getGameTypes(): number[] {

        if(!Check.isNullOrUndefined(this.services.liveStreamPlaying.isSupported)
            && !this.services.liveStreamPlaying.isSupported) {
            return [];
        }

        let baseArray = [...this.listConfiguration.gamesId];
        let gameTypes = this._cycleGamesAndIncrementOffset(baseArray);

        gameTypes = gameTypes.filter((gt) => this.services.games.gamesMap[gt]?.hasVideoURL);

        if(this.services.liveTableFeeds.tablesData.length === 0) {
            return gameTypes;
        } else {
            return gameTypes.filter(gType => this.services.liveTableFeeds.openTablesIds.find(tableId => tableId === gType.toString()));
        }
    }

    get numberOfGamesSkeletons(): number {
        return this._getNumberOfGamesSkeletons();
    }

    protected _getNumberOfGamesSkeletons(): number {
        if(Check.isNullOrUndefined(this.services.liveStreamPlaying.isSupported) || this.services.liveTableFeeds.tablesData.length === 0) {
            return 1;
        }

        return 0;
    }

    protected _renderHeaderIcon(): React.ReactElement | null {
        return (
            <LiveStreamingTitleIconBox>{this.services.translation.translate("LIVE")}</LiveStreamingTitleIconBox>
        );
    }

    protected _renderHeaderText(): string | React.ReactElement {
        return (
            <LiveStreamingListTitleBox>
                {this.title.translation}
            </LiveStreamingListTitleBox>
        );
    }

}
